import styled from "@emotion/styled";
import { Col, Row } from "antd";
import xiangmuImg from "../../../../images/xiangmu-6.png";
import tudiImg from "../../../../images/tudi-3.png";
import zulinImg from "../../../../images/zulin-4.png";
import chuzhiImg from "../../../../images/chuzhi-2.png";
import { useState } from "react";
import { useEffect } from "react";
import request from "../../../../utils/request";
import { useCallback } from "react";

const Layout = styled.div`
  .flex {
    display: flex;
  }
  .box-item {
    background-color: rgba(1, 104, 126, 0.9);
    border: 2px solid #00c9d0;
    box-shadow: 0 0 12px #00383f;
    border-radius: 8px;
    padding: 20px 25px;
    width: 1545px;
    margin-top: 15px;

    .item {
      border: 1px solid #8cc9d5;
      border-radius: 6px;
      padding: 25px 16px;
      margin-bottom: 14px;
    }

    .name {
      font-size: 20px;
      font-family: Source Han Sans CN;
      font-weight: bold;
      color: #36c8da;
    }
    .value {
      font-size: 20px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #36c8da;
    }
  }

  .infos {
    margin-left: 13px;
  }

  .title {
    margin-bottom: 23px;
    font-size: 15px;
    font-family: Source Han Sans CN;
    font-weight: 600;
    color: #ffffff;
    align-items: center;
    img {
      margin-right: 11px;
    }
  }
`;

export const Land: React.FC<{
  id?: number;
}> = ({ id }) => {
  const [details, setDetails] = useState<Record<string, any>>({});

  const getData = () => {
    if (!id) return;
    request.get("/screen/Index/getCompanyLand?id=" + id).then((res) => {
      console.log("res", res);
      setDetails(res.data?.data || {});
    });
  };
  useEffect(() => {
    getData();
  }, []);

  return (
    <Layout>
      <div className="box-item">
        <div className="flex title">
          <img src={tudiImg} width="30" height="30" alt="" />
          <span>出让土地</span>
        </div>
        <Row gutter={153}>
          {details?.land_sell?.map((item: Record<string, any>) => {
            return (
              <Col span={8} key={item.id}>
                <div className="item flex">
                  <img src={xiangmuImg} width="50" height="50" alt="" />
                  <div className="infos">
                    <div className="name">{item.company}</div>
                    <div className="value">{item.fanwei}</div>
                  </div>
                </div>
              </Col>
            );
          })}
        </Row>
      </div>
      <div className="box-item">
        <div className="flex title">
          <img src={zulinImg} width="30" height="30" alt="" />
          <span>租赁土地</span>
        </div>
        <Row gutter={153}>
          {details?.land_lease?.map((item: Record<string, any>) => {
            return (
              <Col span={8} key={item.id}>
                <div className="item flex">
                  <img src={xiangmuImg} width="50" height="50" alt="" />
                  <div className="infos">
                    <div className="name">{item.title}</div>
                    <div className="value">{item.address}</div>
                  </div>
                </div>
              </Col>
            );
          })}
        </Row>
      </div>
      <div className="box-item">
        <div className="flex title">
          <img src={chuzhiImg} width="30" height="30" alt="" />
          <span>低效用地处置</span>
        </div>
        <Row gutter={153}>
          {details?.land_low?.map((item: Record<string, any>) => {
            return (
              <Col span={8} key={item.id}>
                <div className="item flex">
                  <img src={xiangmuImg} width="50" height="50" alt="" />
                  <div className="infos">
                    <div className="name">{item.title}</div>
                    <div className="value">{item.fanwei}</div>
                  </div>
                </div>
              </Col>
            );
          })}
        </Row>
      </div>
    </Layout>
  );
};
